/*
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-10-26 15:09:29
 * @LastEditors: Liu ShuaiBo
 * @LastEditTime: 2021-10-26 15:09:29
 */
import ColumnTypes from "@/utils/ColumnTypes";

const id = {
    key: 'id',
    label: 'ID',
    type: ColumnTypes.TextCell,
};
const user_name = {
    key: 'user_name',
    label: '用户名',
    type: ColumnTypes.TextCell,
}
const state = {
    key: 'state',
    label: '状态',
    type: ColumnTypes.TextCell,
}
const team = {
    key: 'team',
    label: '团队名称',
    type: ColumnTypes.TextCell,
}
const accound = {
    key: 'accound',
    label: '已使用账号数',
    type: ColumnTypes.TextCell,
}
const name = {
    key: 'name',
    label: '联系人姓名',
    type: ColumnTypes.TextCell,
}
const number = {
    key: 'number',
    label: '绑定手机号',
    type: ColumnTypes.TextCell,
}
const password = {
    key: 'password',
    label: '是否修改密码',
    type: ColumnTypes.TextCell,
}
const create_time = {
    key: 'create_time',
    label: '创建时间',
    minWidth: '150',
    type: ColumnTypes.TextCell,
}
const bing_time = {
    key: 'bing_time',
    label: '绑定时间',
    type: ColumnTypes.TextCell,
}
const beizhu = {
    key: 'beizhu',
    label: '备注信息',
    type: ColumnTypes.TextCell,
}

const operations = {
    key: 'operations',
    label: '操作',
    type: ColumnTypes.ButtonsCell
}

export const columns = [
    id,
    user_name,
    state,
    team,
    accound,
    name,
    number,
    password,
    create_time,
    bing_time,
    beizhu,
    operations
]